module.exports = __webpack_public_path__ + "static/media/banesco-street-selected.43efd1d4.svg";